import type { Components } from '@workbench/core';
import { bindWebComponent } from '@seamless/oneweb-ssr/components';

// tabs
export const WbButtonGroup =
  bindWebComponent<Partial<Components.WbButtonGroup>>('wb7-button-group');

export const WbButtonGroupItem = bindWebComponent<
  Partial<Components.WbButtonGroupItem>
>('wb7-button-group-item');

export const WbAccordion =
  bindWebComponent<Partial<Components.WbAccordion>>('wb7-accordion');

export const WbAccordionItem =
  bindWebComponent<Partial<Components.WbAccordionItem>>('wb7-accordion-item');
